import { TooltipContentProps, TooltipRootProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Tooltip } from 'src/components/ui/tooltip';

interface SmallTooltipProps extends TooltipRootProps {
  label: string;
  children: ReactNode;
  placement?: string;
  contentProps?: TooltipContentProps;
}

export default function SmallTooltip({
  label,
  children,
  placement,
  contentProps,
  ...props
}: SmallTooltipProps) {
  return (
    <Tooltip
      positioning={{ placement: (placement || 'bottom') as any }}
      contentProps={{
        ...contentProps,
        css: {
          maxW: '200px',
          ...contentProps?.css,
        },
      }}
      content={label}
      {...props}
    >
      {children}
    </Tooltip>
  );
}
